import React, { Component } from 'react';
import Config from './config';
import 'whatwg-fetch';

import '../css/scheduler.css';
import AbstractList from './abstractList';
import banner from '../media/banner.jpg';
import Calendar from './calendar';
import DatePicker from './datePicker';
import Print from './print';
import SessionDetails from './sessionDetails';
import SessionList from './sessionList';
import SpeakerList from './speakerList';
import TabBar from './tabBar';



class Filter extends Component {
  render() {
    var abstracts = this.props.abstracts;
    var speakers = this.props.speakers;
    var onClickDatePicker = this.props.onClickDatePicker;
    var onClickSpeaker = this.props.onClickSpeaker;
    var speakerId = this.props.speakerId;
    var list;

    switch (this.props.tab) {
      case 3:
        list = <SpeakerList speakerId={speakerId} speakers={speakers} onClick={onClickSpeaker} />;
        break;
      case 4:
      case 5:
      case 6:
        list = <AbstractList abstracts={abstracts}/>;
        break;
      default:
        list = <DatePicker date={this.props.date} onClick={onClickDatePicker}/>;
        break;
    }
    return (
      <div className="Filter">
        {list}
      </div>
    );
  }
}



class Scheduler extends Component {
  constructor(props) {
    super(props);
    this.state = {tab: 1, date: null, sessions: [], speakers: [], speakerId: null, abstracts: []};
  }
  componentDidMount() {
    var self = this;

    fetch(Config.url)
      .then(function(response) {
        return response.json()
      }).then(function(json) {
        self.setState({sessions: json});
        self.getSpeakerList();
      }).then(function () {
        fetch(Config.abstractUrl)
          .then(function (response) {
            return response.json()
          })
          .then(function (json) {
            self.setState({allAbstracts: json});
          }).catch(function(ex) {
            // console.log('parsing failed', ex);
          });
      }).catch(function(ex) {
        // console.log('parsing failed', ex);
      });
  }
  getSpeakerList() {
    var speakers = [];
    var speakerIds = [];
    this.state.sessions.forEach(function (session) {
      session.chairmans.forEach(function (chairman) {
        if (speakerIds.indexOf(chairman.id) === -1) {
          speakerIds.push(chairman.id);
          speakers.push(chairman);
        }
      });
      session.panelists.forEach(function (panelist) {
        if (speakerIds.indexOf(panelist.id) === -1) {
          speakerIds.push(panelist.id);
          speakers.push(panelist);
        }
      });
      session.topics.forEach(function (topic) {
        topic.speaker.forEach(function (speaker) {
          if (speakerIds.indexOf(speaker.id) === -1) {
            speakerIds.push(speaker.id);
            speakers.push(speaker);
          }
        });
      });
    });
    speakers.sort(function(a, b) {
      if (a.firstName.toLowerCase() === b.firstName.toLowerCase()) {
        return (a.lastName > b.lastName ) ? 1 : -1;
      } else {
        return (a.firstName > b.firstName ) ? 1 : -1;
      }
    });
    this.setState({speakers: speakers});
  }
  onClickTabBar = (tab) => {
    window.location.assign('#');
    this.setState({tab: tab.id, date: null, speakerId: null});
    if (tab.abstractType) {
      this.setAbstracts(tab.abstractType);
    }
  }
  onClickDatePicker = (item) => {
    window.location.assign('#');
    this.setState({date: item.name});
  }
  onClickSpeaker = (speakerId) => {
    window.location.assign('#speaker/' + speakerId);
    this.setState({speakerId: speakerId});
  }
  setAbstracts(type = "") {
    if (type !== "") {
      var abstracts = this.state.allAbstracts.filter(function (_abstract) {
        return (_abstract.finalPresentation.toLowerCase() === type.toLowerCase());
      })
      abstracts.sort(function(a, b) {
        if (a.reviewSubspecialty.toLowerCase() === b.reviewSubspecialty.toLowerCase()) {
          // if (a.panelId === b.panelId) {
            return (a.title > b.title ) ? 1 : -1;
          // } else {
          //   return ((a.venueCode + '-' + a.panelId) > (b.venueCode + '-' + b.panelId) ) ? 1 : -1;
          // }
        } else {
          return (a.reviewSubspecialty > b.reviewSubspecialty ) ? 1 : -1;
        }
      });
      this.setState({abstracts: abstracts});
    }
  }
  filter(code, tab, speakerId) {
    var sessions = [];
    if (code) {
      this.state.sessions.forEach(function (session) {
        if (session.code === code) {
          sessions.push(session);
        }
      });
    } else {
      if (tab < 3) {
        var date = this.state.date || Config.defaultDate;
        this.state.sessions.forEach(function (session) {
          if ((date == null) || (session.date === date)) {
            sessions.push(session);
          }
        });
      } else if (tab === 3) {
        if (speakerId != null) {
          this.state.sessions.forEach(function (session) {
            var found = false;
            session.chairmans.forEach(function (chairman) {
              if (chairman.id === speakerId) {
                found = true;
                sessions.push(session);
              }
            });
            if (!found) {
              session.panelists.forEach(function (panelist) {
                if (panelist.id === speakerId) {
                  found = true;
                  sessions.push(session);
                }
              });
            }
            if (!found) {
              session.topics.forEach(function (topic) {
                topic.speaker.forEach(function (speaker) {
                  if (speaker.id === speakerId) {
                    sessions.push(session);
                  }
                });
              });
            }
          });
        }
      }
    }
    return sessions;
  }
  render() {
    var filteredSessions = [];
    var code = window.location.hash.substring(1);
    var sessionList;

    if (code && code !== "" && (code.indexOf("speaker/") === -1) ) { // show one session
      filteredSessions = this.filter(code);
      if (filteredSessions.length === 1) {
        sessionList = <SessionDetails session={filteredSessions[0]} />;
        return (
          <div className="MainContent">
            <Print text="Print This Page" />
            {sessionList}
          </div>
        );
      } else {
        return null;
      }
    } else {
      
      var tab;
      var speakerId;
      if (code && code !== "" && (code.indexOf("speaker/") !== -1) ) { // show one speaker
        speakerId = code.split("speaker/")[1];
        tab = 3;
        filteredSessions = this.filter(null, tab, speakerId);
        sessionList = <SessionList tab={tab} speakerId={speakerId} sessions={filteredSessions} />;

      } else {
        tab = this.state.tab;
        speakerId = this.state.speakerId;
        filteredSessions = this.filter(null, tab, speakerId);
        if ((this.state.tab === 1) || (this.state.tab === 3)) {
          sessionList = <SessionList tab={tab} speakerId={speakerId} sessions={filteredSessions} />;
        } else if (this.state.tab === 2) {
          sessionList = <Calendar date={this.state.date} sessions={filteredSessions} />;
        }
      }

      return (
        <div className="MainContent">
          <Print text="Print This Page" />
          <div><a href={Config.bannerUrl} target="_blank"><img className="no-print" src={banner} alt="banner" width="100%" /></a></div>
          <TabBar onClick={this.onClickTabBar} />
          <Filter tab={tab} date={this.state.date} speakerId={speakerId} speakers={this.state.speakers} abstracts={this.state.abstracts} onClickDatePicker={this.onClickDatePicker} onClickSpeaker={this.onClickSpeaker} />
          {sessionList}
        </div>
      );
    }


  }
}

export default Scheduler;



/** WEBPACK FOOTER **
 ** ./src/js/scheduler.js
 **/